const PRO_ITEMS_COLUMNS = [
  {
    name: "companyName",
    id: "companyName",
    label: "Organization",
    fixed: true,
    width: 200,
    widget: "link"
  },
  {
    name: "email",
    id: "email",
    label: "Email"
  },
  {
    name: "firstName",
    id: "firstName",
    label: "Name",
    widget: "name"
  },
  {
    name: "designation",
    id: "designation",
    label: "Title",
    width: 200
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    widget: "customerstatus"
  }, {
    name: "type",
    id: "type",
    label: "Account Type",
    widget: "customerstatus"
  }, {
    name: "updatedAt",
    id: "updatedAt",
    label: "Status Change",
    widget: "date"
  }, {
    name: "PAN",
    id: "PAN",
    label: "EIN / PAN"
  }, {
    name: "address",
    id: "address",
    label: "Address",
    widget: "address"
  },{
    name: "link",
    id: "link",
    label: "Notes"
  }];

const RATINGS_ITEMS_COLUMNS = [
  {
    name: "email",
    id: "email",
    label: "Email",
    fixed: true,
    widget:'link'
  },
  {
    name: "ratings",
    id: "ratings",
    label: "Overall Rating",
    widget: "ratings"
  },
  {
    name: "comments",
    id: "comments",
    label: "Message"
  },{
    name: "replyComment",
    id: "replyComment",
    label: "Reply"
  },{
    name: "reactions",
    id: "reactions",
    label: "Reactions"
  }, {
    name: "formName",
    id: "formName",
    label: "Rating Type"
  },{
    name: "attachments",
    id: "attachments",
    label: "Attachments"
  }, {
    name: "mobile",
    id: "mobile",
    label: "Mobile"
  },{
    name: "createdAt",
    id: "createdAt",
    label: "Created At",
    widget: "date"
  }];

const PROJECT_ITEMS_COLUMNS = [
  {
    name: "ticketId",
    id: "ticketId",
    label: "Ticket Id",
    width:110,
    widget: "ticketLink",
    fixed: true
  },
  {
    name: "workspaceName",
    id: "workspaceName",
    label: "Workspace"
  },
  {
    name: "summary",
    id: "summary",
    label: "Summary",
    width:200,
    widget: "text"
  },
  {
    name: "priority",
    id: "priority",
    label: "Priority",
    widget: "priority",
    width:130
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    widget: "status",
    width:130
  },
  {
    name: "createdAt",
    id: "createdAt",
    label: "Created",
    widget: "date"
  },
  {
    name: "endDate",
    id: "endDate",
    label: "End Date",
    widget: "date"
  }
];

const PAY_ITEMS_COLUMNS = [
  {
    name: "Payment Id",
    id: "paymentId",
    label: "paymentId",
    fixed: true,
    widget:'link'
  },
  {
    name: "createdBy",
    id: "createdBy",
    label: "email",
    widget:'mobileEmail'
  },
  {
    name: "totalPaid",
    id: "totalPaid",
    label: "Amount",
    widget: "amount"
  },
  {
    name: "status",
    id: "status",
    label: "Status",
    widget: "paymentStatus",
    width: 100
  },
  {
    name: "paidOn",
    id: "paidOn",
    label: "Payment Date",
    widget: "date"
  },
  {
    name: "subscriptionType",
    id: "subscriptionType",
    label: "subscription Type",
    widget: "subscription"
  },
  {
    name: "transactionId",
    id: "transactionId",
    label: "Transaction Id"
  },
  {
    name: "createdAt",
    id: "createdAt",
    label: "Created",
    widget: "date"
  }
 
];

const CUSTOMER_MANAGEMNT_WORKFLOW = [
  {
    "label": "Initial Outreach Sent",
    "value": 1,
    "name": "Initial Outreach Sent",
    "nextStatuses": [
      { "label": "Follow Up #1 Sent", "value": 2, "name": "Follow Up #1 Sent" },
      { "label": "No Response", "value": 11, "name": "No Response" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(65, 82, 110, 0.16)",
    "color": "rgba(65, 82, 110, .9)"
  },
  {
    "label": "Follow Up #1 Sent",
    "value": 2,
    "name": "Follow Up #1 Sent",
    "nextStatuses": [
      { "label": "Follow Up #2 Sent", "value": 3, "name": "Follow Up #2 Sent" },
      { "label": "No Response", "value": 11, "name": "No Response" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(82, 67, 170, 0.16)",
    "color": "rgba(82, 67, 170, .9)"
  },
  {
    "label": "Follow Up #2 Sent",
    "value": 3,
    "name": "Follow Up #2 Sent",
    "nextStatuses": [
      { "label": "Follow Up #3 Sent", "value": 4, "name": "Follow Up #3 Sent" },
      { "label": "No Response", "value": 11, "name": "No Response" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(26, 115, 232, 0.16)",
    "color": "rgba(26, 115, 232, .9)"
  },
  {
    "label": "Follow Up #3 Sent",
    "value": 4,
    "name": "Follow Up #3 Sent",
    "nextStatuses": [
      { "label": "Response Obtained", "value": 5, "name": "Response Obtained" },
      { "label": "No Response", "value": 11, "name": "No Response" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(3, 105, 161, 0.16)",
    "color": "rgba(3, 105, 161, .9)"
  },
  {
    "label": "Response Obtained",
    "value": 5,
    "name": "Response Obtained",
    "nextStatuses": [
      { "label": "Interview Scheduled", "value": 6, "name": "Interview Scheduled" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(0, 163, 191, 0.16)",
    "color": "rgba(0, 163, 191, .9)"
  },
  {
    "label": "Interview Scheduled",
    "value": 6,
    "name": "Interview Scheduled",
    "nextStatuses": [
      { "label": "Hosted Interview", "value": 7, "name": "Hosted Interview" }
    ],
    "background": "rgba(166, 20, 104, 0.16)",
    "color": "rgba(166, 20, 104, .9)"
  },
  {
    "label": "Hosted Interview",
    "value": 7,
    "name": "Hosted Interview",
    "nextStatuses": [
      { "label": "Sent Contract", "value": 8, "name": "Sent Contract" },
      { "label": "Hold", "value": 13, "name": "Hold" },
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Cancelled", "value": 14, "name": "Cancelled" }
    ],
    "background": "rgba(0, 83, 184, 0.16)",
    "color": "rgba(0, 83, 184, .9)"
  },
  {
    "label": "Sent Contract",
    "value": 8,
    "name": "Sent Contract",
    "nextStatuses": [
      { "label": "Scheduled Follow Up Mtg", "value": 9, "name": "Scheduled Follow Up Mtg" }
    ],
    "background": "rgba(97, 37, 0, 0.16)",
    "color": "rgba(97, 37, 0, .9)"
  },
  {
    "label": "Scheduled Follow Up Mtg",
    "value": 9,
    "name": "Scheduled Follow Up Mtg",
    "nextStatuses": [
      { "label": "Active Client", "value": 17, "name": "Active Client" }
    ],
    "background": "rgba(135, 56, 0, 0.16)",
    "color": "rgba(135, 56, 0, .9)"
  },
  {
    "label": "No Response",
    "value": 11,
    "name": "No Response",
    "nextStatuses": [
      { "label": "Response Obtained", "value": 5, "name": "Response Obtained" }
    ],
    "background": "rgba(255,224,224,0.2)",
    "color": "#b71c1c"
  },
  {
    "label": "Hold",
    "value": 13,
    "name": "Hold",
    "nextStatuses": [
      { "label": "Rejected", "value": 15, "name": "Rejected" },
      { "label": "Former Client", "value": 16, "name": "Former Client" }
    ],
    "background": "rgba(47, 58, 143, 0.16)",
    "color": "rgba(47, 58, 143, .9)"
  },
  {
    "label": "Cancelled",
    "value": 14,
    "name": "Cancelled",
    "nextStatuses": [
      { "label": "Former Client", "value": 16, "name": "Former Client" }
    ],
    "background": "rgba(255,205,210,0.3)",
    "color": "#c62828"
  },
  {
    "label": "Rejected",
    "value": 15,
    "name": "Rejected",
    "nextStatuses": [
      { "label": "Initial Outreach Sent", "value": 1, "name": "Initial Outreach Sent" }
    ],
    "background": "rgba(239,154,154,0.3)",
    "color": "#d32f2f"
  },
  {
    "label": "Former Client",
    "value": 16,
    "name": "Former Client",
    "nextStatuses": [
      { "label": "Initial Outreach Sent", "value": 1, "name": "Initial Outreach Sent" }
    ],
    "background": "rgba(9, 30, 66, 0.16)",
    "color": "rgba(9, 30, 66, .9)"
  },
  {
    "label": "Active Client",
    "value": 17,
    "name": "Active Client",
    "nextStatuses": [
      { "label": "Former Client", "value": 16, "name": "Former Client" }
    ],
    "background": "rgba(200,230,201,0.3)",
    "color": "#2e7d32"
  }
];





const ATYPE = [
  // 🟢 Operations / Project
  {
    "activityId": "",
    "name": "",
    "label": "Project Management",
    "value": 1,
    "category": "Operations / Project",
    "background": "rgba(209,196,233,0.16)",
    "color": "#6a1b9a",
    "icon": "StoryOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Research & Analysis",
    "value": 2,
    "category": "Operations / Project",
    "background": "rgba(128,222,234,0.16)",
    "color": "#00897b",
    "icon": "SubtaskOutlined"
  },

  // 🟡 Financial / Funding
  {
    "activityId": "",
    "name": "",
    "label": "Grant Research",
    "value": 3,
    "category": "Financial / Funding",
    "background": "rgba(144,202,249,0.16)",
    "color": "#1565c0",
    "icon": "TaskOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Funding Research",
    "value": 4,
    "category": "Financial / Funding",
    "background": "rgba(128,222,234,0.16)",
    "color": "#00897b",
    "icon": "SupportOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Finance / Billing",
    "value": 5,
    "category": "Financial / Funding",
    "background": "rgba(255,204,128,0.16)",
    "color": "#ff6f00",
    "icon": "StoryOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Compliance & Reporting",
    "value": 6,
    "category": "Financial / Funding",
    "background": "rgba(206,147,216,0.16)",
    "color": "#6a1b9a",
    "icon": "TaskFilled"
  },

  // 🔵 Sales / Business Development
  {
    "activityId": "",
    "name": "",
    "label": "Prospectus",
    "value": 7,
    "category": "Sales / Business Development",
    "background": "rgba(165,214,167,0.16)",
    "color": "#2e7d32",
    "icon": "FeatureRequestFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Lead Generation",
    "value": 8,
    "category": "Sales / Business Development",
    "background": "rgba(255,245,157,0.16)",
    "color": "#f9a825",
    "icon": "ChangerequestFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Proposal / Contracts",
    "value": 9,
    "category": "Sales / Business Development",
    "background": "rgba(187,222,251,0.16)",
    "color": "#0277bd",
    "icon": "ProfitFilled"
  },

  // 🟣 Marketing & Outreach
  {
    "activityId": "",
    "name": "",
    "label": "Marketing Campaigns",
    "value": 10,
    "category": "Marketing & Outreach",
    "background": "rgba(240,98,146,0.16)",
    "color": "#ad1457",
    "icon": "TaskClockCompltionFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Events / Webinars",
    "value": 11,
    "category": "Marketing & Outreach",
    "background": "rgba(179,229,252,0.16)",
    "color": "#0288d1",
    "icon": "QueryOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Content Sharing",
    "value": 12,
    "category": "Marketing & Outreach",
    "background": "rgba(255,224,178,0.16)",
    "color": "#ef6c00",
    "icon": "ImprovementOutlined"
  },

  // 🔴 Customer Engagement & Support
  {
    "activityId": "",
    "name": "",
    "label": "Onboarding",
    "value": 13,
    "category": "Customer Engagement & Support",
    "background": "rgba(255,204,188,0.16)",
    "color": "#d84315",
    "icon": "QueryOutlined"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Meetings / Calls",
    "value": 14,
    "category": "Customer Engagement & Support",
    "background": "rgba(178,223,219,0.16)",
    "color": "#00796b",
    "icon": "SupportFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Follow-ups",
    "value": 15,
    "category": "Customer Engagement & Support",
    "background": "rgba(255,245,157,0.16)",
    "color": "#f9a825",
    "icon": "ClockFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Customer Support",
    "value": 16,
    "category": "Customer Engagement & Support",
    "background": "rgba(197,225,165,0.16)",
    "color": "#33691e",
    "icon": "SupportFilled"
  },

  // 🟤 Relationship & Retention
  {
    "activityId": "",
    "name": "",
    "label": "Feedback / Surveys",
    "value": 17,
    "category": "Relationship & Retention",
    "background": "rgba(240,98,146,0.16)",
    "color": "#ad1457",
    "icon": "EpicFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Loyalty / Rewards",
    "value": 18,
    "category": "Relationship & Retention",
    "background": "rgba(255,213,79,0.16)",
    "color": "#ff8f00",
    "icon": "LineUpFilled"
  },
  {
    "activityId": "",
    "name": "",
    "label": "Community Engagement",
    "value": 19,
    "category": "Relationship & Retention",
    "background": "rgba(179,229,252,0.16)",
    "color": "#0288d1",
    "icon": "FeatureRequestFilled"
  }
];


export {
  PRO_ITEMS_COLUMNS,
  CUSTOMER_MANAGEMNT_WORKFLOW,
  RATINGS_ITEMS_COLUMNS,
  PROJECT_ITEMS_COLUMNS,
  ATYPE,
  PAY_ITEMS_COLUMNS
};